<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">
			<top-nevleft></top-nevleft> 
			
		 <b-col>
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
		
			<b-container fluid class="p-0 mt-2">
					
					<b-row class="m-0">
						<b-col class="col-md-12 col-sm-12 col-xs-12">
							<div class="container-box">
								<b-row class="mt-4 px-3">
									<b-col lg="6" class="text-left">
										<span class="mr-2">Show</span>
										<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
										</b-form-select>
										<span class="ml-2">entries</span>
									</b-col>
									<b-col lg="4" offset-md="2">
										<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
											<b-input-group size="sm">
												<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
												</b-form-input>
												<b-input-group-append>
													<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row class="px-3 pt-3">
									<b-col lg="12">
										<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
											
											<!--<template v-slot:cell(actions)="row">
												<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
												<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
											</template> -->
											<template v-slot:cell(resume)="row">
															<span v-if="row.value!=''"><b-link :href="$root.MEDIAPATH+'resume/'+row.value"> Download Resume</b-link></span>	
															<span v-else> <b-link v-b-popover.hover.top.html="popoverMethod(row.item)" title="Resume">View Resume</b-link><!-- {{row.item.resume_copy}} --></span>
															
											</template>
											<template v-slot:cell(create_date)="row">
											{{$moment(row.value).format('DD-MM-YYYY')}}										
										</template>
											
											<template v-slot:cell(status)="row">
												<b-link @click="replayEmail(row.item)" v-if="row.value == 0"><b-badge pill variant="warning">Reply</b-badge></b-link>
												<b-badge pill variant="success" v-else>Replyed</b-badge>										
											</template>
											<!--<template v-slot:cell(brand_logo)="row">
												<b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img>
												<b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'brands/'+row.value.replace('_rg','_th')">{{row}}</b-img>
											</template>
											<template v-slot:cell(actions)="row">
												<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
												<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
											</template> -->
										</b-table>
									</b-col>
								</b-row>
								<b-row class="px-3">
									<b-col lg="6" class="text-left">
										<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
									</b-col>
									<b-col lg="3" offset-md="3">
										<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
									</b-col>
								</b-row>
							</div>
						</b-col>
					</b-row>
					
					
				
			</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		<replayemail-popup :userData="selected" :subjectT="subjectT" fromEmail="careerslist"></replayemail-popup>
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import ReplayemailPopup from "@/components/admin/replayemail-popup.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"replayemail-popup": ReplayemailPopup,
		
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
		
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/getCareerApplyList',
			selected:{},
			subjectT:'',
			//deleteUrl: this.$root.WEBAPI+'sellerapi/brand-delete',
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'job_id', label: 'JobId'},				
				{ key: 'fname', label: 'Name'},
				{ key: 'email', label: 'Email' },
				{ key: 'mobile', label: 'Phone' },
				{ key: 'resume', label: 'Resume' },
				{ key: 'create_date', label: 'Post Date' },
				{ key: 'status', label: 'Actions' },
				//{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				about_brand: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""]
			},
			emptyItem: {
				id: 0,
				brand_name: '',
				about_brand: '',
				brand_logo: '',
				gallery_images:[""],
                status: 0
			},
			counterindex:1
		};
	},
	methods: {
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.careersApplyList;
					//console.log(self.records);
					//self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					//self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		popoverMethod(obj){
			var resumeHtml=obj.resume_copy;
			
			/* var decoder = new TextDecoder('utf-8');

			var decodedMessage = decoder.decode(resumeHtml);*/
			
			return '<span>' + resumeHtml + '</span>'
		
		},
		replayEmail(item){
			var self = this;
			self.selected=item;
			self.subjectT=item.subject;
			self.$root.$emit('bv::show::modal', 'showShareEmailModal');
			
		}
	}
}
</script>
<style>
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1010;
  display: none;
  max-width: 600px;
  padding: 1px;
  text-align: left;
  white-space: normal;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 6px;
     -moz-border-radius: 6px;
          border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
     -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
     -moz-background-clip: padding;
          background-clip: padding-box;
}
</style>